export {default} from '../newsletter/NewsletterForm';



// WEBPACK FOOTER //
// ./src/components/async/NewsletterForm.js